import { styled } from '@mui/material/styles';
import MuiSkeleton from '@mui/material/Skeleton';

const Skeleton = styled(MuiSkeleton)({
  transform: 'unset',
});

export default Skeleton;
